module.exports = __webpack_public_path__ + "img/图片9.27ac78c5.png";